import { Page } from '@/core/architecture'

import { TicketChargeTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * TicketCharge Page
 * Implemented as a practical sample.
 */
export const TicketCharge: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <TicketChargeTemplate
      state={state}
      onPurchaseGachaTicket={actions.onPurchaseGachaTicket}
    />
  )
}
